export enum MissingEntityType {
    DRIVER = 'driver',
    TRUCK = 'truck',
    NONE = 'none',
}
